import { Input, SkeletonText } from '@chakra-ui/react'
import { useJsApiLoader ,GoogleMap,Marker, Autocomplete} from '@react-google-maps/api'
import React, { useState } from 'react'


const center = {lat:48.8584,lng:2.2945}


const SearchMapComponent = () => {

    const {isLoaded} = useJsApiLoader({
        googleMapsApiKey:process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
        libraries:["places"]
    })


    const [map,setMap] = useState( null)

    if(!isLoaded){
      return  <SkeletonText/>
    }



  return (

    <div className='py-[200px]'>


        <Autocomplete>
            <Input type='text' placeholder='Content'/>
        </Autocomplete>
        <Autocomplete>
            <Input type='text' placeholder='Desitination'/>
        </Autocomplete>


            <GoogleMap center={center} zoom={15} 
            mapContainerStyle={{width:"100%",height:"100%"}}
            options={{zoomControl:false,streetViewControl:false,mapTypeControl:false,fullscreenControl:false}}
           
           onLoad={(map)=>setMap(map)}
           >

                <Marker position={center}/>
            </GoogleMap>
    </div>

  )
}

export default SearchMapComponent